<template>
  <div class="home">
    <h1>{{ $t("message.home_title") }}</h1>
        <p><strong>【{{ $t("message.home_today") }}】<br></strong></p>
        <div class="card" v-for="t in todayText" :key="t.text">
          <div class="card-content">
            <div class="translate_word">
              <p v-if="t.content == t.translated.en">{{t.translated.ja}}</p>
              <p v-if="t.content == t.translated.ja">{{t.translated.en}}</p>
              <p v-if="t.content != t.translated.ja && t.content != t.translated.en">{{t.translated.en}}<br>{{t.translated.ja}}</p>
            </div>
            <p class="traslated_word_content">{{t.content}}</p>
          </div>
          <div class="columns is-marginless">
            <div class="column is-9">
              <span><b-button @click="speech(t.translated.en)" type="is-text"><i class="fas fa-volume-up"></i></b-button></span>
              <span v-if="!t.like"><b-button @click="like(t), t.like = !t.like" type="is-text"><i class="fas fa-star"></i></b-button></span>
              <span v-if="t.like"><b-button type="is-text" disabled><i class="fas fa-star star_like"></i></b-button></span>
            </div>
            <div class="column is-3 share_column">
              <b-button class="is-info" icon-left="twitter" @click="twitterShare(t.translated)">{{ $t("message.home_share") }}</b-button>
            </div>
          </div>
        </div>
        <p><strong>【{{ $t("message.home_yesterday") }}】<br></strong></p>
          <div class="card" v-for="y in yesterdayText" :key="y.text">
            <div class="card-content">
              <div class="translate_word">
                <p v-if="y.content == y.translated.en">{{y.translated.ja}}</p>
                <p v-if="y.content == y.translated.ja">{{y.translated.en}}</p>
                <p v-if="y.content != y.translated.ja && y.content != y.translated.en">{{y.translated.en}}<br>{{y.translated.ja}}</p>
              </div>
              <p class="traslated_word_content">{{y.content}}</p>
            </div>
          <div class="columns is-marginless">
            <div class="column is-9">
              <span><b-button @click="speech(y.translated.en)" type="is-text"><i class="fas fa-volume-up"></i></b-button></span>
              <span v-if="!y.like"><b-button @click="like(y), y.like = !y.like" type="is-text"><i class="fas fa-star"></i></b-button></span>
              <span v-if="y.like"><b-button type="is-text" disabled><i class="fas fa-star star_like"></i></b-button></span>
            </div>
            <div class="column is-3 share_column">
              <b-button class="is-info" icon-left="twitter" @click="twitterShare(y.translated)">{{ $t("message.home_share") }}</b-button>
            </div>
          </div>
          <hr/>
        </div>

        <p><strong>【{{ $t("message.home_week") }}】<br></strong></p>
        <div class="card" v-for="w in weekAgoText" :key="w.text">
          <div class="card-content">
            <div class="translate_word">
              <p v-if="w.content == w.translated.en">{{w.translated.ja}}</p>
              <p v-if="w.content == w.translated.ja">{{w.translated.en}}</p>
              <p v-if="w.content != w.translated.ja && w.content != w.translated.en">{{w.translated.en}}<br>{{w.translated.ja}}</p>
            </div>
            <p class="traslated_word_content">{{w.content}}</p>
          </div>
          <div class="columns is-marginless">
            <div class="column is-9">
              <span><b-button @click="speech(w.translated.en)" type="is-text"><i class="fas fa-volume-up"></i></b-button></span>
              <span v-if="!w.like"><b-button @click="like(w), w.like = !w.like" type="is-text"><i class="fas fa-star"></i></b-button></span>
              <span v-if="w.like"><b-button type="is-text" disabled><i class="fas fa-star star_like"></i></b-button></span>
            </div>
            <div class="column is-3 share_column">
              <b-button class="is-info" icon-left="twitter" @click="twitterShare(w.translated)">{{ $t("message.home_share") }}</b-button>
            </div>
          </div>
          <hr/>
        </div>

        <p><strong>【{{ $t("message.home_month") }}】<br></strong></p>
        <div class="card" v-for="m in monthAgoText" :key="m.text">
          <div class="card-content">
            <div class="translate_word">
              <p v-if="m.content == m.translated.en">{{m.translated.ja}}</p>
              <p v-if="m.content == m.translated.ja">{{m.translated.en}}</p>
              <p v-if="m.content != m.translated.ja && m.content != m.translated.en">{{m.translated.en}}<br>{{m.translated.ja}}</p>
            </div>
            <p class="traslated_word_content">{{m.content}}</p>
          </div>
          <div class="columns is-marginless">
            <div class="column is-9">
              <span><b-button @click="speech(m.translated.en)" type="is-text"><i class="fas fa-volume-up"></i></b-button></span>
              <span v-if="!m.like"><b-button @click="like(m), m.like = !m.like" type="is-text"><i class="fas fa-star"></i></b-button></span>
              <span v-if="m.like"><b-button type="is-text" disabled><i class="fas fa-star star_like"></i></b-button></span>
            </div>
            <div class="column is-3 share_column">
              <b-button class="is-info" icon-left="twitter" @click="twitterShare(m.translated)">{{ $t("message.home_share") }}</b-button>
            </div>
          </div>
          <hr/>
        </div>

  </div>
</template>

<script>
import firebase from 'firebase/app'
import moment from 'moment'
import store from '@/store'
export default {
  name: 'home',
  data(){
    return{
      today_text:[],
      yesterday_text: [],
      weekAgo_text: [],
      monthAgo_text: [],
    }
  },
  mounted(){
    const title = "ホーム｜メモや日記ついでに英語学習"
    const description = "メモや日記ついでに英語学習のホーム画面です。"
    document.title = title
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
    document.querySelector("meta[name='description']").setAttribute('content', description)
    document.querySelector("meta[property='og:description']").setAttribute('content', description)
  },
  computed: {
    user(){
      return this.$store.getters.user;
    },
    todayText(){
        var vm = this
        return vm.today_text.sort((a, b) => {
          return (a.createdAt < b.createdAt) ? 1 : (a.createdAt > b.createdAt) ? -1 : 0;
        });
    },
    yesterdayText(){
        var vm = this
        return vm.yesterday_text.sort((a, b) => {
          return (a.createdAt < b.createdAt) ? 1 : (a.createdAt > b.createdAt) ? -1 : 0;
        });
    },
    weekAgoText(){
        var vm = this
        return vm.weekAgo_text.sort((a, b) => {
          return (a.createdAt < b.createdAt) ? 1 : (a.createdAt > b.createdAt) ? -1 : 0;
        });
    },
    monthAgoText(){
        var vm = this
        return vm.monthAgo_text.sort((a, b) => {
          return (a.createdAt < b.createdAt) ? 1 : (a.createdAt > b.createdAt) ? -1 : 0;
        });
    },

  },
  created(){
    var today = moment().locale('ja').format('l')
    var yesterday = moment().subtract(1, 'days').locale('ja').format('l');
    var weekAgo = moment().subtract(7, 'days').locale('ja').format('l');
    var monthAgo = moment().subtract(1, 'month').locale('ja').format('l');

    store.commit('start')
    firebase.firestore().collection("text").where('uid', '==', this.user.uid ).where('createdDay', '==', today).get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        var data = doc.data()
        data.id = doc.id //idをセッティング
        data.del = false //deleteした時にすぐに反応するための仕掛け
        if(!data.translated){
          var erro_text = {en:"I'm sorry. Translation failed.",ja:"申し訳ありません。まだ翻訳が完了していないか、翻訳に失敗しました。" }
          data.translated = erro_text
        }
        data.like = data.like ? data.like : false;
        this.today_text.push(data)
      });
    }).then(()=>{
      firebase.firestore().collection("text").where('uid', '==', this.user.uid ).where('createdDay', '==', yesterday).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          var data = doc.data()
          data.id = doc.id
          data.del = false
          if(!data.translated){
            var erro_text = {en:"I'm sorry. Translation failed.",ja:"申し訳ありません。まだ翻訳が完了していないか、翻訳に失敗しました。" }
            data.translated = erro_text
          }
          data.like = data.like ? data.like : false;
          this.yesterday_text.push(data)
        });
      });

    }).then(()=>{
      firebase.firestore().collection("text").where('uid', '==', this.user.uid ).where('createdDay', '==', weekAgo).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          var data = doc.data()
          data.id = doc.id
          data.del = false
          if(!data.translated){
            var erro_text = {en:"I'm sorry. Translation failed.",ja:"申し訳ありません。まだ翻訳が完了していないか、翻訳に失敗しました。" }
            data.translated = erro_text
          }
          data.like = data.like ? data.like : false;
          this.weekAgo_text.push(data)
        });
      });

    }).then(()=>{
      firebase.firestore().collection("text").where('uid', '==', this.user.uid ).where('createdDay', '==', monthAgo).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          var data = doc.data()
          data.id = doc.id
          data.del = false
          if(!data.translated){
            var erro_text = {en:"I'm sorry. Translation failed.",ja:"申し訳ありません。まだ翻訳が完了していないか、翻訳に失敗しました。" }
            data.translated = erro_text
          }
          data.like = data.like ? data.like : false;
          this.monthAgo_text.push(data)
        });
      });

    }).then(()=>{
      store.commit('end')
    }).catch(()=>{
      store.commit('end')
    })
  },
  methods: {
      speech(speech_text){
        // 発言を作成
        const uttr = new SpeechSynthesisUtterance(speech_text)
        uttr.lang = "en-US"
        speechSynthesis.speak(uttr)
      },
      like(content){
        console.log(content)
            firebase.firestore().collection('user').doc(content.uid).collection('like').doc(content.id).set({
              uid: content.uid,
              content: content.content,
              createdAt: content.createdAt,
              createdDay: content.createdDay,
              translated: content.translated 
            },{ merge: true }).then(()=>{
              firebase.firestore().collection('text').doc(content.id).set({
                like: true,
              },{ merge: true })
            }).then(()=>{
              this.$buefy.toast.open('エクセレント！お気に入りに登録しました！')
            }).catch(function() {
              this.$buefy.toast.open('おや？お気に入りの登録に失敗しました');
            })
      },
      twitterShare(translated){
        var twitter_share_url = 'https://twitter.com/intent/tweet?text=' + translated.en + "%0a%0a" + translated.ja + "%0a%0a" + "%20%23メモ英" + "%20%23メモや日記ついでに英語学習" + "%20" + "https://translate.ameneko.com/"  
        window.open(twitter_share_url, '_blank')  
      },
    }
}
</script>

<style scoped>
h1{
  font-weight: bold;
  font-size: 1.2em;
  text-align: center;
  padding-bottom: 10px;
}
hr{
  margin:12px;
}
.home{
  max-width: 800px;
  margin:auto;
}
p{
  padding-left:10px;
  padding-right: 10px;
}
span{
  padding-left:4px;
}
.column{
  padding: 10px;
}
.card-content{
  padding-right:10px;
  padding-left:10px;
  padding-bottom: 10px;
}
.star_like {
  color: #FFDB49
}
.share_column{
  text-align: right;
}
.traslated_word_content{
  padding-top: 10px;
  font-size: .9em;
}
.translate_word{
  font-size: 1.1em;
  font-weight: bold;
}
</style>